import { createFeatureFlagPlugin } from '@loadsmart/vue-feature-flags';
import { unleashConfig } from '@/config';

export default createFeatureFlagPlugin({ config: unleashConfig });
